import Base from './Base';

const ENTITY = 'general';
export const REDUCER_NAME = ENTITY;

const initialState = { isFetching: true, isSingleObject: false, values: [] };
const news = new Base(ENTITY, initialState);

export const reducer = news.reducer.bind(news);
news.getAsync.bind(news);
news.putAsync.bind(news);
news.postAsync.bind(news);

export const get = () => {
  return news.getAsync(`${ENTITY}`);
};

export const post = (data) => {
  return news.postAsync(`${ENTITY}`, data);
};



// WEBPACK FOOTER //
// ./src/redux/modules/general.js